import './App.css';
import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LocaleProvider } from './i18n/LocaleContext';
import { ActiveEquipmentCategoryProvider } from './i18n/ActiveEquipmentCategoryContext';
import LocaleLayout from './components/LocaleLayout';
import LocaleRedirect from './components/LocaleRedirect';
import LegacyPathRedirect from './components/LegacyPathRedirect';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import SmartSelector from './components/SmartSelector';
import Home from './pages/Homes';
import { resetBodyScrollLock } from './utils/bodyScrollLock';

const Products = lazy(() => import('./pages/Products'));
const About = lazy(() => import('./pages/About'));
const Cases = lazy(() => import('./pages/Cases'));

function RouteFallback() {
  return <div className="app-route-fallback" aria-hidden="true" />;
}

function App() {
  useEffect(() => {
    resetBodyScrollLock();
  }, []);

  return (
    <LocaleProvider>
      <ActiveEquipmentCategoryProvider>
      <Router unstable_useTransitions={false}>
        <ScrollToTop />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<LocaleRedirect />} />
            <Route path="/products" element={<LegacyPathRedirect segment="products" />} />
            <Route path="/about" element={<LegacyPathRedirect segment="about" />} />
            <Route path="/cases" element={<LegacyPathRedirect segment="cases" />} />
            <Route path="/:lang" element={<LocaleLayout />}>
              <Route index element={<Home />} />
              <Route path="products" element={<Products />} />
              <Route path="cases" element={<Cases />} />
              <Route path="about" element={<About />} />
            </Route>
          </Routes>
        </Suspense>
        <SmartSelector />
        <BackToTop />
      </Router>
      </ActiveEquipmentCategoryProvider>
    </LocaleProvider>
  );
}

export default App;
